module.exports = __webpack_public_path__ + "img/desktop-solid.531a619b.svg";